import React, { memo } from 'react';

import DynamicIconWrapper from '@components/common/DynamicIconWrapper';

import { Icons } from '@icons/icons';

import styles from './SkipFlatNodeButton.module.scss';

interface ISkipFlatNodeButtonProps {
	onClick: () => void;
	isSkipped: boolean;
}

const SkipFlatNodeButton = ({
	onClick,
	isSkipped,
}: ISkipFlatNodeButtonProps) => {
	return (
		<span className={styles.skipButton}>
			<DynamicIconWrapper
				icon={!isSkipped ? Icons.eyeClose : Icons.eyeOpen}
				onClick={onClick}
				tooltipLabel={!isSkipped ? 'Show' : 'Hide'}
			/>
		</span>
	);
};

export default memo(SkipFlatNodeButton);
